/**
 * Copyright (c) 2021 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */
import * as React from 'react';
import { useState } from 'react';
import { ActionButton, Popover } from '@blend/enterprise-components';
import { PipelineFilterContent } from './PipelineFilterContent';
import { OpsDeskFilterParams } from 'blb-constants/pipelineFilter';

export interface Filter {
  columnField: string;
  content: string[];
  operator: string;
}

export namespace PipelineFilter {
  export interface Props {
    filters: OpsDeskFilterParams;
    setFilters: (params: OpsDeskFilterParams) => void;
  }
}

export const PipelineFilter: React.FC<PipelineFilter.Props> = ({ filters, setFilters }) => {
  const [isFilterPopoverOpen, setIsFilterPopoverOpen] = useState(false);

  const closeFilterPopover = () => {
    setIsFilterPopoverOpen(false);
  };

  const toggleFilterPopover = () => {
    setIsFilterPopoverOpen(!isFilterPopoverOpen);
  };

  return (
    <div>
      <Popover
        anchorPosition="bottom-end"
        isOpen={isFilterPopoverOpen}
        onClose={closeFilterPopover}
        popoverContent={<PipelineFilterContent filters={filters} setFilters={setFilters} />}
      >
        <ActionButton
          icon="filter_list"
          id="it-PipelineFilter-addFilters-btn"
          label="Filter"
          onClick={toggleFilterPopover}
          theme="tertiary"
        />
      </Popover>
    </div>
  );
};
